import React, { useState } from "react";
import { Table, Input, Button, Modal, Row } from "antd";
import { lang, MODE_SCREEN } from "../../constants/common.const";
import { CloseCircleOutlined, SaveFilled } from "@ant-design/icons";

const EquipmentContentModal = ({
  mode = MODE_SCREEN.VIEW,
  labelButton,
  value,
  children,
  compo,
  error,
  onCancel = () => {},
  onOK = () => {},
  disabledSave ,
  titleModal = "",
  disbaledButton
}) => {
  const [open, setOpen] = useState(false);
  const handleOk = () => {
    onOK();

    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
    onCancel();
  };

  const styleError = {border:"1px solid red",padding:1}
  return (
    <div style={error ? styleError:{}}  className="wrapSelectModalEquipment">
      {value}
      <Button disabled={disbaledButton} style={{minWidth:62}}  onClick={() => setOpen(true)} className="button-select buttonPC button--info --todo-- wAuto">
        {labelButton}
      </Button>
      <Modal
      title={titleModal}
        centered
        width="40%"
        bodyStyle={{ height: "600px", overflow: "auto" }}
        visible={open}
        onCancel={() => handleCancel()}
        className="modal-msg modal-padding"
        footer={[
          <Row key="footer-row" justify="end" gutter={8}>
            <Button
            disabled={disabledSave}
              className="buttonPC button--info --todo-- wAuto"
              onClick={() => handleOk()}
            >
              <SaveFilled />
              {lang.SAVE}
            </Button>
            <Button
              onClick={() => handleCancel()}
              className="buttonPC button--outline --todo-- wAuto"
            >
              <CloseCircleOutlined />
              {lang.CLOSE}
            </Button>
          </Row>,
        ]}
      >
        {compo}
      </Modal>
    </div>
  );
};

export default EquipmentContentModal;
